import { ApiModel } from 'lib/interfaces/api';

// Non exhaustive list, add more as needed
enum Prefix {
  Account = 'act',
  Case = 'case',
  Inquiry = 'inq',
  InquirySession = 'iqse',
  Tag = 'tag',
  Transaction = 'txn',
  Verification = 'ver',
}

const PREFIX_TO_TYPE: Readonly<Record<Prefix, ApiModel>> = Object.freeze({
  [Prefix.Account]: ApiModel.Account,
  [Prefix.Case]: ApiModel.Case,
  [Prefix.Inquiry]: ApiModel.Inquiry,
  [Prefix.InquirySession]: ApiModel.InquirySession,
  [Prefix.Tag]: ApiModel.Tag,
  [Prefix.Transaction]: ApiModel.Transaction,
  [Prefix.Verification]: ApiModel.Verification,
});

type TokenType = (typeof PREFIX_TO_TYPE)[keyof typeof PREFIX_TO_TYPE];

class PrefixedIdValidator {
  private static readonly PREFIX_TO_TYPE = PREFIX_TO_TYPE;

  // this regex mirrors PrefixedToken app/lib/prefixed_token.rb:30
  private static readonly MIN_UID_LENGTH = 20;
  private static readonly MAX_UID_LENGTH = 28;
  private static readonly ID_REGEX = new RegExp(
    `^([a-z]+)_([a-zA-Z0-9]{${this.MIN_UID_LENGTH},${this.MAX_UID_LENGTH}})$`,
  );

  static isValid(value: string): boolean {
    const match = value.match(this.ID_REGEX);
    return match != null && match[1] in this.PREFIX_TO_TYPE;
  }

  static getObjectType(value: string): TokenType | null {
    const match = value.match(this.ID_REGEX);
    if (!match) return null;

    const prefix = match[1] as keyof typeof PREFIX_TO_TYPE;
    return this.PREFIX_TO_TYPE[prefix];
  }
}

export { PrefixedIdValidator };
